import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenValidationService {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  isTokenValid(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      this.handleInvalidToken();
      return false;
    }

    return true;
  }

  private handleInvalidToken(): void {
    // Limpiar datos locales
    localStorage.removeItem('token');
    localStorage.removeItem('dataUser');
    
    // Redirigir al login
    this.auth.logout({
      returnTo: window.location.origin
    });
  }
} 